module.exports = __webpack_public_path__ + "0585b42bed2470f61e448b206d3f0b79.jpg";